import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { DCService } from "../../../services/index";

@Component({
  selector: "add-edit-scrap-bit",
  templateUrl: "./addEditScrapBitOutward.html",
})
export class addEditScrapBitOutward {
  row: any;
  data: any;
  mode = "Add";
  dcdata: any = { scrap_out_id: "", total_kg: 0 };
  dcdata1: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  desData: any = {
    totDes: 0,
  };
  barcodeList = [];
  brandList = [];
  partyList = [];
  unitList: any;
  rd_season = [];
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  dcList = [
    {
      barcode: "",
      scrap_kg: 0
    },
  ];
  woList: any = [];
  noofpcs: number;
  export: boolean = false;
  printRes: any;
  printPreview = [];
  isLoadMask: Promise<any>;

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  isLoading = false;
  @Input() _params: any;
  scrap_out_id: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    if (this.mode == "Edit" || this.mode == "View") {
      const designdata = Object.assign({}, val["data"]);
      this.dcdata = designdata;

      this.getdcdesignList(this.dcdata.scrap_out_id);
      this.getbarcodeList();
      // this.onChangeCode()
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private dcService: DCService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.data = {
      dcdata1: [],
    };
  }
  ngOnInit() {
    if (this.mode == "Add") {
      this.dcdata.dc_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getRefAuto();
      this.getbarcodeList();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#scrap_to").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if (nextEl == "barcodegood") {
      $("#" + this.page_id + "barcode-0").focus();
    } else {
      $("#" + this.page_id + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    if (fld == "color") {
      let totdes = 0;
      const designlist = [];
      for (let i = 0; i < this.dcList.length; i++) {
        const design = this.dcList[i].barcode;
        if (design != "") {
          if (designlist.indexOf(design) == -1) {
            designlist.push(design);
            totdes++;
          }
        }
      }
      this.dcdata.total_design = totdes;
    }

    let nxtInd = ind,
      barcode = this.dcList[ind]["barcode"],
      scrap_kg = this.dcList[ind]["scrap_kg"];
    this.calctot();

    const nxtRow = $("#row-" + ind).next("tr");
    if (fld == "barcode" && nxtRow.length == 0) {
      if (this.dcList[ind].scrap_kg == 0) {
        swal({
          title:
            "Please Enter the Valid Mtr for design " +
            this.dcList[ind].barcode,
          timer: 1000,
          showConfirmButton: false,
        });
        return false;
      }


      const len = this.dcList.length;
      const barcode = this.dcList[len - 1]["barcode"];
      const qty = this.dcList[len - 1].scrap_kg;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "design" + "-" + nxtInd).focus();

      if (barcode != "" && nxtInd == len) {
        this.dcList.push({
          barcode: "",
          scrap_kg: 0
        });

        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();
        this.calctot();
      } else if (barcode == "" && nxtInd == len) {
        const a = nxtInd - 1;
        $("#" + this.page_id + "barcode" + "-" + a).focus();
      } else {
        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();

        return false;
      }
    }

    //   nxtInd = this.designList.length - 1;
    else if (fld == "item_name") {
      const nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 200);
    }
  }

  isRowEmpty(ind) {
    const data = this.dcList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].barcode != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    const that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.dcList.length > 1) {
          that.dcList.splice(ind, 1);
          let totdes = 0;
          const designlist = [];
          for (let i = 0; i < that.dcList.length; i++) {
            const design = that.dcList[i].barcode;
            if (design != "") {
              if (designlist.indexOf(design) == -1) {
                designlist.push(design);
                totdes++;
              }
            }
          }
          that.dcdata.total_design = totdes;

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
          that.calctot();
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getRefAuto() {
    this.dcService.getScrapBitRefAuto({}).then((res: any) => {
      this.dcdata.ref_no = res;
    });
  }


  getbarcodeList() {
    let params = {};
    this.dcService.scrapBarcodeList(params).then((res: any) => {
      this.barcodeList = res.data;
      for (let i = 0; i < this.barcodeList.length; i++) {
        this.barcodeList[i].barcode = this.barcodeList[i].barcode
          .toString()
          .padStart(6, "0");
      }
    });
  }


  getdcdesignList(id) {
    const params = {
      scrap_out_id: id,
    };
    this.dcService.dcScrapBitDesignList(params).then((res: any) => {
      this.dcList = res.data;
      for (let i = 0; i < this.dcList.length; i++) {
        this.dcList[i].barcode = this.dcList[i].barcode
          .toString()
          .padStart(6, "0");
      }
      // this.calcPieces();
    });
  }
  //Barcode Reader

  onChangeCode(barcode, design, ind) {
    if (barcode.length == 6) {
      const data = _.filter(this.barcodeList, { barcode: barcode });
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.barcode == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.barcode = "";
        design.scrap_kg = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists",
        });
      } else {

        if(data.length <= 0){
          design.barcode = "";
          design.scrap_kg = "";
          swal("Please enter valid barcode");
          return;
        }

        design.id = data[0]["scrap_id"];
        design.barcode = data[0]["barcode"];
        design.scrap_kg = data[0]["scrap_kg"] > 0 ? data[0]["scrap_kg"] : 0;
        this.calctot();

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].barcode;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
      }
    }
  }
  checkQty(qty, row, ind) {
    this.barcodeList;
    let that = this;
    this.barcodeList.forEach(function (element) {
      if (row.barcode == element.barcode) {
        if (qty > element.mtrs) {
          that.barcodeList[0].qty = 0;
          that.dcList[ind].scrap_kg = 0;
        }
      }
    });
    if (qty > row.qty) {
      this.dcList[ind].scrap_kg = 0;
    }
  }
  onSelectItem($event, design, ind) {
    // debugger;
    const barcode = $event.item.barcode;
    if (barcode.length == 6) {
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.barcode == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.barcode = "";
        design.scrap_kg = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists",
        });
      } else {
        if(!$event.item.scrap_id){
          swal("Please enter valid barcode");
          return;
        }

        design.barcode = $event.item.barcode;
        design.scrap_kg = $event.item.scrap_kg > 0 ? $event.item.scrap_kg : 0;
        this.calctot();

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].barcode;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
      }
    }
  }

  oncheckemptyrow() {
    const design = this.dcList;
    const desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].barcode != "") {
        desList.push(design[i]);
      }
    }
    this.dcList = desList;
    this.onSaveOrder();
  }
  calctot() {
    let totmtr = 0;
    for (let i = 0; i < this.dcList.length; i++) {
      const dcdata = this.dcList[i];
      totmtr += dcdata.scrap_kg;
    }

    this.dcdata.total_kg = totmtr;
  }


  onSaveOrder(): void {
    
    if (
      !this.dcdata.scrap_to ||
      !this.dcdata.dc_date 
    ) {
      swal("Please make sure all are entered");
    } else {
      const params: any = Object.assign({}, this.dcdata);
      params["tabevent"] = undefined;
      params["dcList"] = JSON.stringify(this.dcList);
      params["mode"] = this.mode;
      params["dc_date"] = this.datePipe.transform(
        params["dc_date"],
        "yyyy-MM-dd"
      );
      const that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Scrap Bit Dc?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.dcService
          .addUpdateScrapBitDC(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }

            if (res.response.success) {
              that.printRes = res;

              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });

              const tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);

            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            const res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/scrapBit/addEditScrapBitOutward.ts